<template>
    <div>
        <layout>
            <Search slot="header-bar" placeholder="请输入关键字搜索" v-model="search.input" @search="onRefresh">
                <div slot="left-icon">
                    <button slot="left-icon" @click="statePanel=true"
                            style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">
                        {{orderState}}
                    </button>
                    <!--<button slot="left-icon" @click="unitPanel=true"-->
                    <!--style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">-->
                    <!--{{unitName}}-->
                    <!--</button>-->
                </div>
            </Search>
            <PullRefresh v-model="isReFresh" @refresh="onRefresh">
                <List
                        style="margin-top:-5px;padding: 5px 12px"
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        loading-text="拼命加载中..."
                        @load="onLoad"
                        :offset="50"
                        :immediate-check="true"
                >
                    <OrderItem v-for="item in orders" :key="item.id" :order="item"/>
                </List>
            </PullRefresh>
        </layout>
        <SelectTreePopup :show="unitPanel" :defaultSelected="search.unitId?{id:search.unitId,name:search.unitName}:{}"
                         :treeData="unitTree"
                         :defaultTitle="unitName" @ok="onUnitOk" @cancel="unitPanel = false"/>
        <SelectDict :showAll="true" dictKey="ORDER_TSAK_STATE" :show="statePanel"
                    @cancel="statePanel=false" @ok="onStateOk"/>
    </div>
</template>

<script>
    import {List, PullRefresh, Search} from "vant"
    import OrderItem from "../components/OrderItem"
    import {mapGetters} from 'vuex'
    import {formatSearchData} from "@/utils/format";
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import SelectDict from "@/components/SelectPopup/SelectDict";


    export default {
        components: {OrderItem, Search, PullRefresh, List, SelectTreePopup, SelectDict},
        props: {},
        data() {
            return {
                isReFresh: false,
                loading: false,
                finished: false,
                unitPanel: false,
                statePanel: false,
                search: {
                    unitId: null,
                    unitName: null,
                    state: null,
                    stateName: null,
                    input: null
                },
                orders: []
            }
        },
        computed: {
            ...mapGetters({unitTree: 'global/unitList'}),
            unitName() {
                return this.search.unitName || "选择单位"
            },
            orderState() {
                return this.search.stateName || "全部"
            }
        },
        created() {
            this.$initUnit(this.search)
        },
        mounted() {
        },
        methods: {
            onStateOk(data) {
                this.search.stateName = data.codeName;
                if (data.code == "All") this.search.state = null;
                else this.search.state = data.code;
                this.onRefresh()
                this.statePanel = false;
            },
            onUnitOk(data) {
                this.unitPanel = false
                this.search.unitId = data.id
                this.search.unitName = data.name
                this.onRefresh()
            },
            onRefresh() {
                this.isReFresh = true;
                this.orders = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                const data = {
                    fullText: this.search.input,
                    state: this.search.state,
                    unitId: this.$default.unitOrOrgan.id,
                    onlyAssignMyself: true,
                    size: 20,
                    page: this.orders.length / 20 + 1
                }
                formatSearchData(data)
                this.$http.tokiot.order.task.list(data).then(res => {
                    if (res) {
                        this.orders.push(...res.rows);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.orders.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
        },
        watch: {}
    }
</script>

<style scoped>


</style>